import { combineReducers } from 'redux'
import generalReducer from './reducers/generalReducer.js'
import cushionReducer from './reducers/cushionReducer.js'
import fabricsReducer from './reducers/fabricsReducer.js'
import layoutReducer from './reducers/layoutReducer.js'
import kitReducer from './reducers/kitReducer.js'

export const createRootReducer = () =>
  combineReducers({
    general: generalReducer,
    cushion: cushionReducer,
    fabrics: fabricsReducer,
    layout: layoutReducer,
    kit: kitReducer,
  })
